import m from "../../../../geodata/es2015/region/world/africaHigh";
window.am4geodata_region_world_africaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/world/africaHigh.js
// module id = null
// module chunks = 